module.exports = __webpack_public_path__ + "img/P4-en.f9b39c8d.png";